<template>
  <div class="date-time-picker" :class="{ time: timeVisible }">
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      v-model="menu"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="100px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          :value="viewValue"
          mask="time"
          :label="label"
          return-masked-value
        ></v-text-field>
        <!-- TODO: v-textfield should have 'readonly' property but due to bug in vuetify 2.3.0-beta.7 this property had to be removed -->
      </template>
      <v-container v-if="menu">
        <v-layout row wrap>
          <v-flex v-if="timeVisible">
            <v-time-picker :landscape="true" full-width format="24hr" v-model="dialogData.time"></v-time-picker>
          </v-flex>

          <v-flex>
            <v-date-picker v-model="dialogData.date" no-title :locale="language"></v-date-picker>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="controls">
          <v-flex>
            <v-btn block @click="menu = false">{{ $t('ok') }}</v-btn>
          </v-flex>

          <v-flex v-if="clearable">
            <v-btn block @click="clear()">{{ $t('clear') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['value', 'label', 'clearable', 'useTime', 'asObject'],

  data () {
    return {
      menu: false,
      language: null,
      dialogData: {
        date: null,
        time: null
      }
    }
  },

  computed: {
    timeVisible () {
      return this.useTime || this.useTime === undefined
    },

    date () {
      return this.formated('DD.MM.YYYY')
    },

    time () {
      return this.formated('HH:mm')
    },

    viewValue () {
      return (this.date + ' ' + (this.timeVisible ? this.time : '')).trim()
    },
  },

  methods: {
    merge (date, time) {
      let result = (date && time) ? moment(date + ' ' + time).valueOf() : null

      if (this.asObject)
        result = new Date(result)

      this.$emit('input', result)
      this.menu = false
    },

    formated (format) {
      return this.value ? moment(this.value).format(format) : null
    },

    clear () {
      this.dialogData.date = null
      this.dialogData.time = null

      this.menu = false
    }
  },

  created () {
    this.language = window.localStorage.getItem('userLanguage')
  },

  watch: {
    menu (value) {
      if (value) {
        this.dialogData = { date: this.formated('YYYY-MM-DD'), time: this.time }
      } else {
        this.merge(this.dialogData.date, this.dialogData.time)
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .date-time-picker {
    min-width: 85px;

    &.time {
      min-width: 130px;
    }
  }

  ::v-deep {
    .container {
      padding: 0;
    }

    .v-picker {
      border: none;
      border-radius: 0px;
    }

    .v-picker--time {
      width: 400px;
      height: 100%;

      .v-time-picker-title__time {
        text-align: center;
      }

      .v-picker__body {
        display: flex;
        align-items: center;
        flex-direction: row;
      }
    }



    .controls {
      .v-btn {
        margin: 0;
        border-radius: 0;
        box-shadow: none !important;
        border-left: 1px solid #ddd;
        border-top: 1px solid #ddd;
      }

      .v-flex:first-child {
        .v-btn:first-child {
          border: none;
        }
      }
    }
  }
</style>
